import React, { useState } from 'react';
import { useStartDate } from './StartDateContext';
import { useLoading } from './LoadingContext';
import DatePicker from 'react-datepicker';
import { FiCalendar, FiChevronLeft, FiChevronRight, FiX } from 'react-icons/fi';
import 'react-datepicker/dist/react-datepicker.css';

export default function StartDate() {
  const { startDate, setStartDate } = useStartDate();
  const { showLoading, hideLoading } = useLoading();
  const [showPicker, setShowPicker] = useState(false);

  const moveDateByWeeks = (weeks) => {
    showLoading('Startdatum wird geändert...');
    
    // Kurze Verzögerung für bessere UX
    setTimeout(() => {
      const newDate = new Date(startDate);
      newDate.setDate(newDate.getDate() + (weeks * 7));
      setStartDate(newDate);
      hideLoading();
    }, 300);
  };

  const handleDatePickerChange = (date) => {
    showLoading('Startdatum wird geändert...');
    setShowPicker(false);
    
    // Kurze Verzögerung für bessere UX
    setTimeout(() => {
      setStartDate(date);
      hideLoading();
    }, 300);
  };

  const handleWheel = (e) => {
    e.preventDefault();
    // Negative deltaY bedeutet nach oben scrollen (eine Woche vor)
    // Positive deltaY bedeutet nach unten scrollen (eine Woche zurück)
    const weeks = e.deltaY > 0 ? -1 : 1;
    moveDateByWeeks(weeks);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 , width: '100%'}}>
      
      
      <button
        onClick={() => moveDateByWeeks(-1)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 4,
          display: 'flex',
          alignItems: 'center'
        }}
        aria-label="Eine Woche zurück"
        title="Eine Woche zurück"
      >
        <FiChevronLeft size={20} />
      </button>
      
      <span 
        onWheel={handleWheel}
        style={{ 
          cursor: 'pointer',
          userSelect: 'none',
          padding: '4px 8px',
          borderRadius: '4px',
          transition: 'background-color 0.2s'
        }}
        onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
        onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
        title="Mit dem Mausrad scrollen um das Datum zu ändern"
      >
        {startDate.toLocaleDateString()}
      </span>
      
      <button
        onClick={() => moveDateByWeeks(1)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 4,
          display: 'flex',
          alignItems: 'center'
        }}
        aria-label="Eine Woche vor"
        title="Eine Woche vor"
      >
        <FiChevronRight size={20} />
      </button>
      
      <button
        onClick={() => setShowPicker(v => !v)}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 4,
          display: 'flex',
          alignItems: 'center'
        }}
        aria-label="Datum wählen"
      >
        <FiCalendar size={20} />
      </button>
      {showPicker && (
        <div style={{ position: 'absolute', zIndex: 100 }}>
          <div style={{ position: 'relative' }}>
            <button
              onClick={() => setShowPicker(false)}
              style={{
                position: 'absolute',
                top: '-12px',
                right: '-12px',
                background: 'white',
                border: '2px solid #ddd',
                cursor: 'pointer',
                padding: '3px',
                display: 'flex',
                alignItems: 'center',
                zIndex: 101,
                borderRadius: '50%',
                boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                width: '24px',
                height: '24px',
                justifyContent: 'center'
              }}
              title="Kalender schließen"
            >
              <FiX size={16} />
            </button>
            <DatePicker
              selected={startDate}
              onChange={handleDatePickerChange}
              inline
              startOpen
              calendarStartDay={1}
            />
          </div>
        </div>
      )}
    </div>
  );
}